import React from "react";

const PencilIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.36167 11.866C4.14808 12.438 3.9675 12.966 3.80617 13.5004C4.68617 12.8615 5.73208 12.4563 6.93933 12.3051C9.24292 12.0173 11.2898 10.4965 12.3257 8.58526L10.991 7.25151L12.2863 5.95442L13.2029 5.03684C13.5971 4.64267 14.0417 3.91484 14.5119 2.86617C9.385 3.66092 6.24542 6.80051 4.36075 11.866H4.36167ZM13.5833 7.25059L14.5 8.16634C13.5833 10.9163 10.8333 13.6663 7.16667 14.1247C4.72008 14.4308 3.192 16.1111 2.5815 19.1663H0.75C1.66667 13.6663 3.5 0.833008 17.25 0.833008C16.3333 3.58026 15.4185 5.41267 14.5028 6.33026L13.5833 7.25059Z"
        fill="#B6B5BB"
      />
    </svg>
  );
};

export default PencilIcon;
